<template>
  <div class="header">
    <div class="flex justify-between items-center header-content">
      <div class="left">
        <div>
          <img
            src="@/assets/imgs/Mask group.png"
            alt="crestcard"
            class="logo-img"
          />
        </div>
      </div>
      <!-- PC端菜单 -->
      <div class="flex justify-start items-center right desktop-menu">
        <el-button type="info" class="customBtn loginBtn" @click="toLogin">{{
          $t("登录")
        }}</el-button>
        <el-select
          v-model="curLanguage"
          class="language-select"
          @change="handleLanguageChange"
        >
          <el-option
            v-for="lang in langs"
            :key="lang.value"
            :label="lang.text"
            :value="lang.value"
          />
        </el-select>
      </div>
      <!-- 移动端菜单按钮 -->
      <div class="mobile-controls">
        <el-select
          v-model="curLanguage"
          class="mobile-language-select"
          @change="handleLanguageChange"
        >
          <el-option
            v-for="lang in langs"
            :key="lang.value"
            :label="lang.text"
            :value="lang.value"
          />
        </el-select>
        <div class="mobile-menu-button" @click="drawerVisible = true">
          <img src="@/assets/imgsnew/hbcd.png" alt="menu" />
        </div>
      </div>
    </div>

    <!-- 移动端抽屉菜单 -->
    <div
      v-if="drawerVisible"
      class="mobile-drawer-overlay"
      @click="drawerVisible = false"
    ></div>
    <div class="mobile-drawer" :class="{ 'drawer-open': drawerVisible }">
      <div class="drawer-content">
        <div class="drawer-header">
          <div class="close-button" @click="drawerVisible = false">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="drawer-body">
          <div class="menu-buttons">
            <el-button type="info" class="drawer-btn" @click="toLogin">
              {{ $t("登录") }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "header-page",
  data() {
    return {
      drawerVisible: false,
      langs: [
        { text: "English", value: "en" },
        { text: "中文", value: "zh" },
        { text: "日本语", value: "ja" },
      ],
      curLanguage: localStorage.getItem("accept_language"),
      currentLan: "",
    };
  },
  methods: {
    handleCommand(command) {
      localStorage.setItem("accept_language", command.value);
      this.$i18n.locale = command.value;
      this.currentLan = this.langs.find(
        (item) => item.value === command.value
      )?.text;
      window.location.reload();
    },
    toLogin() {
      window.open("https://card.crestcard.cc/login?lang=" + this.$i18n.locale);
    },
    toHome() {
      window.location.href = "https://crestcard.cc";
    },
    toActive() {
      window.open("https://crestcard.cc/opencard");
    },
    handleLanguageChange(value) {
      localStorage.setItem("accept_language", value);
      this.$i18n.locale = value;
      this.currentLan = this.langs.find((item) => item.value === value)?.text;
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
// 全局样式
.el-select-dropdown {
  background-color: #1a1a1a !important;
  border: 1px solid #363636 !important;
  border-radius: 16px !important;
  margin-top: 8px !important;

  .el-select-dropdown__item {
    color: #846c37 !important;
    background-color: transparent !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    height: 36px !important;
    line-height: 36px !important;
    padding: 0 20px !important;

    &.selected,
    &.hover,
    &:hover {
      color: #ffffff !important;
      background: linear-gradient(180deg, #846c37 0%, #5f4b1f 100%) !important;
      border-radius: 12px !important;
    }
  }

  .el-select-dropdown__list {
    background-color: transparent !important;
    padding: 0px 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 10px;
}
.header {
  width: 100%;
  background-color: #000000;

  .header-content {
    max-width: 1440px;
    height: 82px;
    padding: 18px 60px;
    margin: 0 auto;
    color: #fff;
  }

  .left {
    display: flex;
    align-items: center;

    .logo-img {
      width: 120px;
      height: 34px;
    }

    font-family: "MiSans-Bold";
    font-size: 26px;
    line-height: 35.67px;
    text-align: left;
  }

  .right {
    .loginBtn {
      color: #ffffff;
      background: linear-gradient(180deg, #846c37 0%, #5f4b1f 100%);
    }
    .language {
      margin-left: 20px;
      cursor: pointer;
    }
    .active {
      background-color: transparent;
      background: linear-gradient(180deg, #846c37 0%, #5f4b1f 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "MiSans-Demibold";
      font-size: 14px;
      font-weight: 600;
      line-height: 18.56px;
      text-align: left;
    }

    .language-select {
      margin-left: 20px;
      width: 110px;

      :deep(.el-input__inner) {
        background-color: #000000;
        border: 2px solid #846c37;
        color: #846c37;
        font-size: 16px;
        font-weight: 600;
        height: 36px;
        border-radius: 40px;
        padding: 0 20px;
      }

      :deep(.el-input__suffix) {
        right: 15px;
      }

      :deep(.el-input__suffix-inner) {
        .el-select__caret {
          color: #846c37;
          transform: scale(1.2);

          svg {
            width: 16px;
            height: 16px;
            fill: currentColor;
          }
        }
      }
    }
  }

  .mobile-controls {
    display: none;
    align-items: center;
    gap: 12px;

    .mobile-language-select {
      width: 140px;
      display: flex;
      align-items: center;

      :deep(.el-input__inner) {
        background-color: #1a1a1a;
        border: 1px solid #846c37;
        color: #846c37;
        font-size: 20px;
        font-weight: 500;
        height: 102px;
        line-height: 102px;
        border-radius: 26px;
        padding: 0 24px;
      }

      :deep(.el-input__suffix) {
        display: none;
      }
    }

    .mobile-menu-button {
      flex-shrink: 0;
      width: 102px;
      height: 102px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #1a1a1a;
      border: 1px solid #846c37;
      border-radius: 26px;
      padding: 0;

      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .el-button + .el-button,
  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-left: 0px;
  }

  .header {
    .header-content {
      padding: 12px 16px;
      height: 76px;
      display: flex;
      align-items: center;
    }

    .desktop-menu {
      display: none;
    }

    .mobile-controls {
      display: flex;
      align-items: center;
      height: 52px;
    }

    .left {
      .logo-img {
        width: 80px;
        height: 22px;
      }
    }
  }
}

.mobile-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.mobile-drawer {
  position: fixed;
  top: 0;
  right: -300px;
  width: 300px;
  height: 100%;
  background: #1a1a1a;
  z-index: 1000;
  transition: 0.3s ease-in-out;

  &.drawer-open {
    right: 0;
  }

  .drawer-content {
    padding: 20px;

    .drawer-header {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 30px;

      .close-button {
        cursor: pointer;
        padding: 0;
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 30px;
        transition: background-color 0.3s;
        background: #1a1a1a;
        border: 1px solid #846c37;

        i {
          font-size: 40px;
          color: #846c37;
        }
      }
    }

    .drawer-body {
      .menu-buttons {
        display: flex;
        flex-direction: column;
        gap: 15px;

        .drawer-btn {
          width: 100%;
          height: 44px;
          border-radius: 22px;
          font-size: 16px;

          &.el-button--info {
            color: #ffffff;
            background: linear-gradient(180deg, #846c37 0%, #5f4b1f 100%);
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .header {
    .header-content {
      padding: 12px 16px;
      height: 76px;
    }

    .desktop-menu {
      display: none;
    }

    .mobile-controls {
      display: flex;
      align-items: center;
    }

    .left {
      .logo-img {
        width: 80px;
        height: 22px;
      }
    }
  }
}
</style>
